import React from "react";
import { AppProvider } from "@context/AppContext";

import GTM from "@utils/GTM";
import { setLastPageUrl } from "./src/utils/pageTracker";


import "./static/fonts/fonts.css"
import "./src/styles/global.css"

let hasTrackCTAInitialized = false;

export const onRouteUpdate = ({ location, prevLocation }) => {
    GTM.pageView();
    if (!hasTrackCTAInitialized) {
        GTM.trackCTA();
        hasTrackCTAInitialized = true;
    }
    if (typeof window !== "undefined") {
        setLastPageUrl(prevLocation?.href || document.referrer || window.location.href);
    }
};

export const wrapRootElement = ({ element }) => (
    <AppProvider>{element}</AppProvider>
);
